import React from "react";

import VarzService from "../../service/varz.js";
import Page from "../../view/layout/page.js";

class Varz extends React.Component {
  static get displayName() {
    return "Varz";
  }

  constructor(props) {
    super(props);

    this.state = {
      varz: {},
    };
  }

  componentDidMount() {
    VarzService.get()
      .then((resp) => {
        if (resp && resp.data.data) {
          this.setState({ varz: resp.data.data });
        }
      })
      .catch((e) => {
        if (e && e.message) {
          this.setState({ varz: e.message });
        }
      });
  }

  render() {
    return (
      <Page title="Cortex Varz">
        <pre>{JSON.stringify(this.state.varz, null, 2)}</pre>
      </Page>
    );
  }
}

module.exports = Varz;
